const guideSlides = [
  {
    id: 1,
    type: 'cover',
    image: '/images/guide/cover.png',
    title: 'مرحبًا بك في منصة دوز التعليمية',
    text: 'منصتك المتكاملة للتعلم عن بعد..\nتعلم أونلاين في أي وقت ومن أي مكان',
    buttonText: 'ابدأ الآن',
    duration: 11,
    audio: '/audio/guide/slide-1.mp3',
  },
  {
    id: 2,
    type: 'slide',
    image: '/images/guide/slide-1.png',
    title: 'للتسجيل',
    text: 'ابدأ بفتح القائمة الجانبية لتسجيل الدخول او التسجيل',
    duration: 6,
    audio: '/audio/guide/slide-2.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '3.5%',
    dotLeft: '8.5%',
    mobileDotTop: '5.2%',
    mobileDotLeft: '8.5%',
    mobileObjectPosition: '0% 0%',
    mobileImageScale: 0.85,
  },
  {
    id: 3,
    type: 'slide',
    image: '/images/guide/slide-2.png',
    title: 'إنشاء حساب',
    text: 'اضغط على "إنشاء حساب" للانضمام واستكشاف الدورات التدريبية',
    duration: 4,
    audio: '/audio/guide/slide-3.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '31%',
    dotLeft: '30%',
    mobileDotTop: '36%',
    mobileDotLeft: '30%',
    mobileObjectPosition: '0% 20%',
    mobileImageScale: 0.85,
  },
  {
    id: 4,
    type: 'slide',
    image: '/images/guide/slide-3.png',
    title: '',
    text: 'أدخل البيانات التالية لبدء التسجيل على المنصة.',
    duration: 4,
    audio: '/audio/guide/slide-4.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '38%',
    dotLeft: '45%',
    mobileDotTop: '31%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 50%',
    mobileImageScale: 0.85,
  },
  {
    id: 5,
    type: 'slide',
    image: '/images/guide/slide-3.png',
    title: '',
    text: 'اسم المستخدم - رقم الجوال - البريد الإلكتروني - كلمة المرور وإعادة كلمة المرور',
    duration: 8,
    audio: '/audio/guide/slide-5.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '38%',
    dotLeft: '45%',
    mobileDotTop: '31%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 50%',
    mobileImageScale: 0.85,
  },
  {
    id: 6,
    type: 'slide',
    image: '/images/guide/slide-3.png',
    title: '',
    text: 'قم بإتمام التسجيل للحصول على جميع ميزات المنصة.',
    duration: 3,
    audio: '/audio/guide/slide-6.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '73%',
    dotLeft: '25%',
    mobileDotTop: '84.5%',
    mobileDotLeft: '25%',
    mobileObjectPosition: '0% 50%',
    mobileImageScale: 0.85,
  },
  {
    id: 7,
    type: 'slide',
    image: '/images/guide/slide-3.png',
    title: '',
    text: 'هل لديك حساب؟ انتقل لتسجيل الدخول واستئناف التدريب.',
    duration: 4,
    audio: '/audio/guide/slide-7.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '73%',
    dotLeft: '73%',
    mobileDotTop: '84.5%',
    mobileDotLeft: '72%',
    mobileObjectPosition: '0% 50%',
    mobileImageScale: 0.85,
  },
  {
    id: 8,
    type: 'slide',
    image: '/images/guide/slide-7.png',
    title: '',
    text: 'أدخل رقم الجوال وكلمة المرور لتسجيل الدخول.',
    duration: 4,
    audio: '/audio/guide/slide-8.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '45.5%',
    dotLeft: '50%',
    mobileDotTop: '44%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 50%',
    mobileImageScale: 0.85,
  },
  {
    id: 9,
    type: 'slide',
    image: '/images/guide/slide-7.png',
    title: '',
    text: 'اضغط على تسجيل الدخول',
    duration: 2,
    audio: '/audio/guide/slide-9.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '65%',
    dotLeft: '49%',
    mobileDotTop: '72.5%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 50%',
    mobileImageScale: 0.85,
  },
  {
    id: 10,
    type: 'slide',
    image: '/images/guide/slide-9.png',
    title: '',
    text: 'استخدم القائمة الجانبية للوصول إلى الإعدادات والدورات المشتراة والملف الشخصي',
    duration: 7,
    audio: '/audio/guide/slide-10.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '3.5%',
    dotLeft: '8.5%',
    mobileDotTop: '5.2%',
    mobileDotLeft: '8.5%',
    mobileObjectPosition: '0% 0%',
    mobileImageScale: 0.85,
  },
  {
    id: 11,
    type: 'slide',
    image: '/images/guide/slide-10.png',
    title: '',
    text: 'قم بالنقر على الإعدادات',
    duration: 2,
    audio: '/audio/guide/slide-11.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '86%',
    dotLeft: '38%',
    mobileDotTop: '79%',
    mobileDotLeft: '39%',
    mobileObjectPosition: '0% 99%',
    mobileImageScale: 0.85,
  },
  {
    id: 12,
    type: 'slide',
    image: '/images/guide/slide-11.png',
    title: '',
    text: 'الملف الشخصي يحتوي على البريد الإلكتروني ورقم الجوال ويمكنك أيضاً تغيير الرقم السري من هنا وإضافة نبذة شخصية',
    duration: 10,
    audio: '/audio/guide/slide-12.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '56%',
    dotLeft: '48%',
    mobileDotTop: '76%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 17%',
    mobileImageScale: 0.85,
  },
  {
    id: 13,
    type: 'slide',
    image: '/images/guide/slide-12.png',
    title: '',
    text: 'تصفح دوراتك وكتبك بسهولة من خلال لوحة حسابك الشخصية.',
    duration: 6,
    audio: '/audio/guide/slide-13.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '72%',
    dotLeft: '50%',
    mobileDotTop: '81%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 55%',
    mobileImageScale: 0.85,
  },
  {
    id: 14,
    type: 'slide',
    image: '/images/guide/slide-13.png',
    title: '',
    text: 'اضغط على "متابعة الدورة" لاستئناف التدريب',
    duration: 3,
    audio: '/audio/guide/slide-14.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '42.5%',
    dotLeft: '50%',
    mobileDotTop: '53.5%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 20%',
    mobileImageScale: 0.85,
  },
  {
    id: 15,
    type: 'slide',
    image: '/images/guide/slide-14.png',
    title: '',
    text: 'اضغط على محتوى الدورة لمشاهدة أقسام ومحتويات الدورة التدريبية',
    duration: 5,
    audio: '/audio/guide/slide-15.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '27.5%',
    dotLeft: '30%',
    mobileDotTop: '41.5%',
    mobileDotLeft: '28%',
    mobileObjectPosition: '0% 0%',
    mobileImageScale: 0.85,
  },
  {
    id: 16,
    type: 'slide',
    image: '/images/guide/slide-15.png',
    title: '',
    text: 'قم بتوسيع القسم للوصول بسهولة لجميع محتويات القسم',
    duration: 5,
    audio: '/audio/guide/slide-16.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '36%',
    dotLeft: '48%',
    mobileDotTop: '54.5%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 0%',
    mobileImageScale: 0.85,
  },
  {
    id: 17,
    type: 'slide',
    image: '/images/guide/slide-16.png',
    title: '',
    text: 'اضغط على "المحتوى المراد فتحة او التنقل بين الاقسام ',
    duration: 5,
    audio: '/audio/guide/slide-17.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '43.8%',
    dotLeft: '50%',
    mobileDotTop: '77%',
    mobileDotLeft: '50%',
    mobileObjectPosition: '0% 0%',
    mobileImageScale: 0.85,
  },
  {
    id: 18,
    type: 'slide',
    image: '/images/guide/slide-17.png',
    title: '',
    text: 'انطلق واستمتع بمشاهدة المحاضرة وابدأ بتأسيس معرفتك.',
    duration: 5,
    audio: '/audio/guide/slide-18.mp3',
    imageScale: 0.85,
    imageTranslateY: 55,
    dotTop: '26.8%',
    dotLeft: '51%',
    mobileDotTop: '40.6%',
    mobileDotLeft: '50.8%',
    mobileObjectPosition: '0% 0%',
    mobileImageScale: 0.85,
  },
  {
    id: 19,
    type: 'slide',
    image: '/images/guide/slide-18.png',
    title: '',
    text: 'شكرا للمشاهدة مع تمنياتنا لكم بالتوفيق\nمنصة دوز التعليمية',
    buttonText: 'إعادة',
    duration: 6,
    audio: '/audio/guide/slide-19.mp3',
    mobileDotTop: '48.6%',
    mobileDotLeft: '55%',
    mobileObjectPosition: '0% 50%',
    mobileImageScale: 0.85,
    
  },
];

export default guideSlides;
